
import * as moment from "moment";

import "./veriDateRange.scss";

import { IComboBox } from "@interfaces/IComboBox";
import { TranslationService } from "@services/translation.service";
import { DateRange } from "@reports/_services/dynamicReports.service";

export interface IVeriDateRangeComponentBindings {
    selectedDateRange: DateRange;
    startDate: Date;
    endDate: Date;

    onRangeChanged: (args: { startDate: Date, endDate: Date, selectedDateRange: DateRange }) => void;
}

class VeriDateRangeComponentController implements angular.IComponentController {

    dateRange = DateRange;
    selectedDateRange = DateRange.Today;

    startDate: Date;
    startHour: number;
    startMinute: number;

    endDate: Date;
    endHour: number;
    endMinute: number;

    onRangeChanged: (args: { startDate: Date, endDate: Date, selectedDateRange: DateRange }) => void;

    static $inject = ["translationService"];
    constructor( private readonly translationService: TranslationService) {}

    dateRangeOptions: IComboBox[] = [
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.oneDay"), Value: DateRange.Today },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.twoDays"), Value: DateRange.Yesterday },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.thisWeek"), Value: DateRange.ThisWeek },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.lastWeek"), Value: DateRange.LastWeek },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.thisMonth"), Value: DateRange.ThisMonth },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.lastMonth"), Value: DateRange.LastMonth },
        { Name: this.translationService.t("veriDateRange.dateRangeOptions.custom"), Value: DateRange.Custom }
    ];

    $onInit(): void {
        this.syncDates();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["startDate"] || onChangesObj["endDate"]) {
            this.syncDates();
        }
        
        if (onChangesObj["selectedDateRange"]) {
            this.setSelectDateRange();
        }
    }

    timeChanged(updateDateRange: boolean = true): void {
        this.startDate = moment(this.startDate).hour(this.startHour).minute(this.startMinute).toDate();

        this.endDate = moment(this.endDate).hour(this.endHour).minute(this.endMinute).toDate();

        if (updateDateRange) {
            this.setSelectDateRange();
        }

        if (this.onRangeChanged) {
            this.onRangeChanged({
                startDate: this.startDate,
                endDate: this.endDate,
                selectedDateRange: this.selectedDateRange
            });
        }
    }

    selectedDateRangeChanged() {
        this.selectedDateRange = Number(this.selectedDateRange);

        if (this.selectedDateRange === DateRange.Today ||
            this.selectedDateRange === DateRange.Yesterday ||
            this.selectedDateRange === DateRange.Week ||
            this.selectedDateRange === DateRange.Month ||
            this.selectedDateRange === DateRange.ThisWeek ||
            this.selectedDateRange === DateRange.ThisMonth ||
            this.selectedDateRange === DateRange.Latest3Weeks) {
            this.endDate = moment().toDate();
        }

        switch (this.selectedDateRange) {
            case DateRange.Today:
                this.startDate = moment().toDate();
                break;
            case DateRange.Yesterday:
                this.startDate = moment().add(-1, "days").toDate();
                break;
            case DateRange.Week:
                this.startDate = moment().add(-1, "weeks").toDate();
                break;
            case DateRange.Month:
                this.startDate = moment().add(-1, "months").toDate();
                break;
            case DateRange.ThisWeek:
                this.startDate = moment().startOf("isoWeek").toDate();
                break;
            case DateRange.ThisMonth:
                this.startDate = moment().startOf("month").toDate();
                break;
            case DateRange.Latest3Weeks:
                this.startDate = moment().startOf("isoWeek").add(-2, "weeks").toDate();
                break;
            case DateRange.LastWeek:
                this.startDate = moment().add(-1, "weeks").startOf("isoWeek").toDate();
                this.endDate = moment().add(-1, "weeks").endOf("isoWeek").toDate();
                break;
            case DateRange.LastMonth:
                this.startDate = moment().add(-1, "months").startOf("month").toDate();
                this.endDate = moment().add(-1, "months").endOf("month").toDate();
                break;
        }

        this.timeChanged(false);
    }

    private setSelectDateRange() {
        const startDate = moment(this.startDate);

        if (startDate.isSame(moment(), "days")) {
            this.selectedDateRange = DateRange.Today;
        } else if (startDate.isSame(moment().add(-1, "days"), "day")) {
            this.selectedDateRange = DateRange.Yesterday;
        } else {
            this.selectedDateRange = DateRange.Custom;
        }
    }

    private syncDates(): void {
        const startMoment = moment(this.startDate);
        this.startDate = startMoment.toDate();
        this.startHour = startMoment.hour();
        this.startMinute = startMoment.minute();

        const endMoment = moment(this.endDate);
        this.endDate = endMoment.toDate();
        this.endHour = endMoment.hour();
        this.endMinute = endMoment.minute();
    }
}

export class VeriDateRangeComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            startDate: "<",
            endDate: "<",
            selectedDateRange: "<?",
            hideRanges: "<?",
            hideTimes: "<?",
            onRangeChanged: "&"
        };

        this.controller = VeriDateRangeComponentController;
        this.template = require("./veriDateRange.html");
    }
}
